import { SyncOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { WarningColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconSyncWarningOutlined: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <SyncOutlined {...props} type="sync" style={{ ...props.style, color: WarningColor }} />;
};
